(function() {
var modal = document.querySelector('.section-wine-resort-popup__container');
  document.addEventListener('click', (event) => {
    let element = event.target;
    if (element.classList.contains('popupTextImage')) {
      showModal();
      generateModalSliderBySection(element);
      hideReservationDates();
      showModalSlider();
    } else if (element.classList.contains('reservationDate')) {
      showModal();
      generateModalSlider(element);
      hideReservationDates();
      showModalSlider();
    } else if (element.classList.contains('reservationDate--popup')) {
      showModal();
      hideModalSlider();
      showReservationDates();
    } else if (element.classList.contains('section-carousels__image')) {
      console.log('desktop');
      showModal();
      generateModalSlider(element);
      hideReservationDates();
      showModalSlider();
    } else if (element.classList.contains('section-listing__image-bg--rooms')) {
      console.log('mobile');
      showModal();
      generateModalSliderMobile(element);
      hideReservationDates();
      showModalSlider();
     } else if (element.classList.contains('more-listing')) {
      showModal();
      generateModalDetailMore(element);
      hideReservationDates();
      showModalSlider();
    } else if (element.classList.contains('load-more-gallery')) {
      showModal();
      generateModalSliderGallery(element);
      hideReservationDates();
      showModalSlider();
    } else if (element.classList.contains('section-listing__image-bg')) {
      showModal();
      generateModalDetailMoreImg(element);
      hideReservationDates();
      showModalSlider();
    } else if (element.classList.contains('details-popup')) {
      showModal();
      generateModalDetail(element);
      hideReservationDates();
      showModalSlider();
    } else if (element.classList.contains('details-to-form')) {
      closeModal();
      detailsToForm(element);
    } else if (element.classList.contains('details-to-form-modal')) {
      closeModal();
      detailsToFormModal(element);
    } else if (element.classList.contains('section-wine-resort-popup__close') || element == document.querySelector('.section-wine-resort-popup__close svg')) {
      closeModal();
    } else if (element.classList.contains('hide-calendar')) {
      hideReservationDates(),
        showModalSlider();
    } else if (element.classList.contains('scroll-to-form')) {
      if (document.querySelector('.section-contact-form')) {
        closeModal();
        scrollToForm();
      }
    }
  });

  function generateModalDetail(element) {
    console.log(element);
    let referenceElement = element ? element : false;
    if (referenceElement) {
    let paragraph = referenceElement.parentNode.parentNode.parentNode
    let templateSlider = `
      <div class="modal-details i">
        <div class="modal-details__content">
          <h3 class="modal-details__title"> ${paragraph.dataset.name}</h3>
          <div class="modal-details__paragraph">
            ${paragraph.dataset.paragraph}
            <div class="modal-details__reserve">
              <button class="btn btn-primary scroll-to-form details-to-form-modal">${paragraph.dataset.modaldetail}</button>
            </div>
          </div>
        </div>
        <div class="modal-details__slider">
          <div class="modal-slider">
      `;

      let parentSliderElement = referenceElement.parentNode.parentNode.parentElement.querySelector('.section-listing__slider');
      let images = parentSliderElement.querySelectorAll('.slick-slide:not(.slick-cloned) .section-listing__image');
      images.forEach((img) => {
        if (img.dataset.image) {
          templateSlider += `
            <div class="modal-slide">
              <div class="modal-slide-content">
              <img src="${img.dataset.image}" class="modal-image " />
              </div>
            </div>`
        }
      });
      templateSlider += `</div></div></div>`;
      let modalBox = document.querySelector('.section-wine-resort-popup__box');
      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.modal-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
  }

  function generateModalDetailMore(element) {
    console.log(element);
    let referenceElement = element ? element : false;
    if (referenceElement) {
    let paragraph = referenceElement.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
    console.log(referenceElement);
    let templateSlider = `
      <div class="modal-details i">
        <div class="modal-details__content">
          <h3 class="modal-details__title"> ${paragraph.dataset.name}</h3>
          <div class="modal-details__paragraph">
            ${paragraph.dataset.paragraph}
            <div class="modal-details__reserve">
              <button class="btn btn-primary scroll-to-form details-to-form-modal">${paragraph.dataset.modaldetail}</button>
            </div>
          </div>
        </div>
        <div class="modal-details__slider">
          <div class="modal-slider">
      `;

      let parentSliderElement = referenceElement.parentNode.parentNode.parentNode.parentNode.parentNode
      console.log(parentSliderElement)
      let images = parentSliderElement.querySelectorAll('.slick-slide:not(.slick-cloned) .section-listing__image');
      images.forEach((img) => {
        if (img.dataset.image) {
          templateSlider += `
            <div class="modal-slide">
              <div class="modal-slide-content">
              <img src="${img.dataset.image}" class="modal-image " />
              </div>
            </div>`
        }
      });
      templateSlider += `</div></div></div>`;
      let modalBox = document.querySelector('.section-wine-resort-popup__box');
      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.modal-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9514 28.1135C39.0033 27.8053 38.9103 27.4774 38.6724 27.2396L28.298 16.8651C27.9074 16.4746 27.2743 16.4746 26.8837 16.8651L26.7018 17.0471C26.3112 17.4376 26.3112 18.0708 26.7018 18.4613L36.354 28.1135L26.7018 37.7658C26.3112 38.1563 26.3112 38.7895 26.7018 39.18L26.8837 39.362C27.2743 39.7525 27.9074 39.7525 28.298 39.362L38.6724 28.9875C38.9103 28.7497 39.0033 28.4218 38.9514 28.1135Z"
        fill="#ffffff" />
      <g filter="url(#filter0_d_24_12)">
        <circle
          cx="29.942"
          cy="28"
          r="24.5"
          stroke="#ffffff"
          shape-rendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_12"
          x="0.942032"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_12" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_12"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        prevArrow: `<button type="button" class="slick-prev">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_24_12)">
        <path d="M4.61594 27.998C4.61594 41.5278 15.5849 52.496 29.1159 52.496C42.647 52.496 53.6159 41.5278 53.6159 27.998C53.6159 14.4682 42.647 3.5 29.1159 3.5C15.5849 3.5 4.61594 14.4682 4.61594 27.998Z" stroke="#ffffff" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4821 27.7318C20.5214 27.5506 20.6114 27.3783 20.7522 27.2375L31.1266 16.8639C31.5172 16.4734 32.1503 16.4734 32.5409 16.8639L32.7228 17.0458C33.1133 17.4363 33.1133 18.0695 32.7228 18.46L23.0007 28.1813L32.5832 37.763C32.9737 38.1535 32.9737 38.7867 32.5832 39.1772L32.4012 39.3591C32.0107 39.7496 31.3775 39.7496 30.987 39.3591L20.6126 28.9855C20.2719 28.6448 20.2284 28.1196 20.4821 27.7318Z"
          fill="#ffffff" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_13"
          x="0.115936"
          y="0"
          width="58"
          height="57.996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset
            dy="1">
          <feGaussianBlur
            stdDeviation="2">
          <feComposite
            in2="hardAlpha"
            operator="out">
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_13" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_13"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
  }

  function generateModalDetailMoreImg(element) {
    console.log('eccomi');
    let referenceElement = element ? element : false;
    if (referenceElement) {
    let paragraph = referenceElement.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode
    console.log(paragraph)
    let templateSlider = `
      <div class="modal-details i">
        <div class="modal-details__content">
          <h3 class="modal-details__title"> ${paragraph.dataset.name}</h3>
          <div class="modal-details__paragraph">
            ${paragraph.dataset.paragraph}
            <div class="modal-details__reserve">
              <button class="btn btn-primary scroll-to-form details-to-form-modal">${paragraph.dataset.modaldetail}</button>
            </div>
          </div>
        </div>
        <div class="modal-details__slider">
          <div class="modal-slider">
      `;

      let parentSliderElement = referenceElement.parentNode.parentNode.parentNode.parentNode.parentNode
      let images = parentSliderElement.querySelectorAll('.slick-slide:not(.slick-cloned) .section-listing__image');
      images.forEach((img) => {
        if (img.dataset.image) {
          templateSlider += `
            <div class="modal-slide">
              <div class="modal-slide-content">
              <img src="${img.dataset.image}" class="modal-image " />
              </div>
            </div>`
        }
      });
      templateSlider += `</div></div></div>`;
      let modalBox = document.querySelector('.section-wine-resort-popup__box');
      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.modal-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9514 28.1135C39.0033 27.8053 38.9103 27.4774 38.6724 27.2396L28.298 16.8651C27.9074 16.4746 27.2743 16.4746 26.8837 16.8651L26.7018 17.0471C26.3112 17.4376 26.3112 18.0708 26.7018 18.4613L36.354 28.1135L26.7018 37.7658C26.3112 38.1563 26.3112 38.7895 26.7018 39.18L26.8837 39.362C27.2743 39.7525 27.9074 39.7525 28.298 39.362L38.6724 28.9875C38.9103 28.7497 39.0033 28.4218 38.9514 28.1135Z"
        fill="#ffffff" />
      <g filter="url(#filter0_d_24_12)">
        <circle
          cx="29.942"
          cy="28"
          r="24.5"
          stroke="#ffffff"
          shape-rendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_12"
          x="0.942032"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_12" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_12"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        prevArrow: `<button type="button" class="slick-prev">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_24_12)">
        <path d="M4.61594 27.998C4.61594 41.5278 15.5849 52.496 29.1159 52.496C42.647 52.496 53.6159 41.5278 53.6159 27.998C53.6159 14.4682 42.647 3.5 29.1159 3.5C15.5849 3.5 4.61594 14.4682 4.61594 27.998Z" stroke="#ffffff" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4821 27.7318C20.5214 27.5506 20.6114 27.3783 20.7522 27.2375L31.1266 16.8639C31.5172 16.4734 32.1503 16.4734 32.5409 16.8639L32.7228 17.0458C33.1133 17.4363 33.1133 18.0695 32.7228 18.46L23.0007 28.1813L32.5832 37.763C32.9737 38.1535 32.9737 38.7867 32.5832 39.1772L32.4012 39.3591C32.0107 39.7496 31.3775 39.7496 30.987 39.3591L20.6126 28.9855C20.2719 28.6448 20.2284 28.1196 20.4821 27.7318Z"
          fill="#ffffff" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_13"
          x="0.115936"
          y="0"
          width="58"
          height="57.996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset
            dy="1">
          <feGaussianBlur
            stdDeviation="2">
          <feComposite
            in2="hardAlpha"
            operator="out">
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_13" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_13"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
  }  

  function generateModalSliderListing(element) {
    let templateSlider = `<div class="modal-slider">`;
    let referenceElement = element ? element : false;
    if (referenceElement) {
      let parentSliderElement = referenceElement.closest('.section-listing__slider');
      let images = parentSliderElement.querySelectorAll('.slick-slide:not(.slick-cloned) .section-listing__image');

      images.forEach((img) => {
        if (img.dataset.image) {
          templateSlider += `<div class="modal-slide">
              <div class="modal-slide-content">
              <div class="modal-slide-cta-header">
                  <div class="modal-slide-description">${img.dataset.name}</div>
              </div>
              <img src="${img.dataset.image}" class="modal-image ${img.dataset.ratio}" />
                <div class="modal-slide-cta">
                  <div class="modal-slide-description">${img.dataset.description}</div>
                  <div class="modal-slide-reserve">
                    <a href="${img.dataset.bookpage}">
                      <button class="btn btn-primary">${img.dataset.book}</button>
                    </a>
                  </div>
                </div>
              </div>
            </div>`
        }
      });
      templateSlider += `</div>`;
      let modalBox = document.querySelector('.section-wine-resort-popup__box');
      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.modal-slider').slick({
        dots: false,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9514 28.1135C39.0033 27.8053 38.9103 27.4774 38.6724 27.2396L28.298 16.8651C27.9074 16.4746 27.2743 16.4746 26.8837 16.8651L26.7018 17.0471C26.3112 17.4376 26.3112 18.0708 26.7018 18.4613L36.354 28.1135L26.7018 37.7658C26.3112 38.1563 26.3112 38.7895 26.7018 39.18L26.8837 39.362C27.2743 39.7525 27.9074 39.7525 28.298 39.362L38.6724 28.9875C38.9103 28.7497 39.0033 28.4218 38.9514 28.1135Z"
        fill="#909090" />
      <g filter="url(#filter0_d_24_12)">
        <circle
          cx="29.942"
          cy="28"
          r="24.5"
          stroke="#909090"
          shape-rendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_12"
          x="0.942032"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_12" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_12"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        prevArrow: `<button type="button" class="slick-prev">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_24_12)">
        <path d="M4.61594 27.998C4.61594 41.5278 15.5849 52.496 29.1159 52.496C42.647 52.496 53.6159 41.5278 53.6159 27.998C53.6159 14.4682 42.647 3.5 29.1159 3.5C15.5849 3.5 4.61594 14.4682 4.61594 27.998Z" stroke="#919191" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4821 27.7318C20.5214 27.5506 20.6114 27.3783 20.7522 27.2375L31.1266 16.8639C31.5172 16.4734 32.1503 16.4734 32.5409 16.8639L32.7228 17.0458C33.1133 17.4363 33.1133 18.0695 32.7228 18.46L23.0007 28.1813L32.5832 37.763C32.9737 38.1535 32.9737 38.7867 32.5832 39.1772L32.4012 39.3591C32.0107 39.7496 31.3775 39.7496 30.987 39.3591L20.6126 28.9855C20.2719 28.6448 20.2284 28.1196 20.4821 27.7318Z"
          fill="#909090" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_13"
          x="0.115936"
          y="0"
          width="58"
          height="57.996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset
            dy="1">
          <feGaussianBlur
            stdDeviation="2">
          <feComposite
            in2="hardAlpha"
            operator="out">
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_13" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_13"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
  }

  function generateModalSliderGallery(element) {
    let templateSlider = `<div class="modal-slider">`;
    let referenceElement = element ? element : false;
    if (referenceElement) {
      let parentSliderElement = referenceElement.closest('.load-more-gallery');
      console.log(parentSliderElement);
      let images = parentSliderElement.parentNode.parentNode.querySelectorAll('.thun-gallery-image');
      console.log(images);

      images.forEach((img) => {
        if (img.dataset.image) {
          templateSlider += `<div class="modal-slide gallery">
              <div class="modal-slide-content">
              <img class="horizontal" src="${img.dataset.image}" />
              </div>
            </div>`
        }
      });
      templateSlider += `</div>`;
      let modalBox = document.querySelector('.section-wine-resort-popup__box');
      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.modal-slider').slick({
        dots: false,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9514 28.1135C39.0033 27.8053 38.9103 27.4774 38.6724 27.2396L28.298 16.8651C27.9074 16.4746 27.2743 16.4746 26.8837 16.8651L26.7018 17.0471C26.3112 17.4376 26.3112 18.0708 26.7018 18.4613L36.354 28.1135L26.7018 37.7658C26.3112 38.1563 26.3112 38.7895 26.7018 39.18L26.8837 39.362C27.2743 39.7525 27.9074 39.7525 28.298 39.362L38.6724 28.9875C38.9103 28.7497 39.0033 28.4218 38.9514 28.1135Z"
        fill="#909090" />
      <g filter="url(#filter0_d_24_12)">
        <circle
          cx="29.942"
          cy="28"
          r="24.5"
          stroke="#909090"
          shape-rendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_12"
          x="0.942032"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_12" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_12"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        prevArrow: `<button type="button" class="slick-prev">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_24_12)">
        <path d="M4.61594 27.998C4.61594 41.5278 15.5849 52.496 29.1159 52.496C42.647 52.496 53.6159 41.5278 53.6159 27.998C53.6159 14.4682 42.647 3.5 29.1159 3.5C15.5849 3.5 4.61594 14.4682 4.61594 27.998Z" stroke="#919191" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4821 27.7318C20.5214 27.5506 20.6114 27.3783 20.7522 27.2375L31.1266 16.8639C31.5172 16.4734 32.1503 16.4734 32.5409 16.8639L32.7228 17.0458C33.1133 17.4363 33.1133 18.0695 32.7228 18.46L23.0007 28.1813L32.5832 37.763C32.9737 38.1535 32.9737 38.7867 32.5832 39.1772L32.4012 39.3591C32.0107 39.7496 31.3775 39.7496 30.987 39.3591L20.6126 28.9855C20.2719 28.6448 20.2284 28.1196 20.4821 27.7318Z"
          fill="#909090" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_13"
          x="0.115936"
          y="0"
          width="58"
          height="57.996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset
            dy="1">
          <feGaussianBlur
            stdDeviation="2">
          <feComposite
            in2="hardAlpha"
            operator="out">
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_13" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_13"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
  }

  function generateModalSlider(element) {
    let referenceElement = element ? element : false;

    let dataElement = referenceElement.closest('.section-carousels__slide');



    let templateSlider = `<div class="modal-slider">
                            <div class="modal-slide-cta-header"  style="width: 60%; margin: 0 auto;">
                              <div class="modal-slide-description">${dataElement.dataset.name}</div>
                            </div>
                            <div class="slider-wrapper"  style="width: 60%; margin: 0 auto;">
                            <div class="slider">`;
    
    if (referenceElement) {
      let parentSliderElement = referenceElement.closest('.section-carousels__slider');
      
      let images = parentSliderElement.querySelectorAll('.slick-slide:not(.slick-cloned) .section-carousels__image');
      images.forEach((img) => {
        if (img.dataset.image) {
          templateSlider += `<div style="height:500px; width:500px; background:url(${img.dataset.image}) center no-repeat; background-size:contain;"></div>`;
        }
      });
      templateSlider += `</div></div>
                        <div class="modal-slide-cta"  style="width: 60%; margin: 0 auto;">
                          <div class="modal-slide-description">${dataElement.dataset.description}</div>
                          <div class="modal-slide-reserve">
                            <a href="${dataElement.dataset.bookpage}">
                              <button class="btn btn-primary">${dataElement.dataset.book}</button>
                            </a>
                          </div>
                        </div>
                      </div>`;
      let modalBox = document.querySelector('.section-wine-resort-popup__box');
      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.slider').slick({
        dots: false,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9514 28.1135C39.0033 27.8053 38.9103 27.4774 38.6724 27.2396L28.298 16.8651C27.9074 16.4746 27.2743 16.4746 26.8837 16.8651L26.7018 17.0471C26.3112 17.4376 26.3112 18.0708 26.7018 18.4613L36.354 28.1135L26.7018 37.7658C26.3112 38.1563 26.3112 38.7895 26.7018 39.18L26.8837 39.362C27.2743 39.7525 27.9074 39.7525 28.298 39.362L38.6724 28.9875C38.9103 28.7497 39.0033 28.4218 38.9514 28.1135Z"
        fill="#909090" />
      <g filter="url(#filter0_d_24_12)">
        <circle
          cx="29.942"
          cy="28"
          r="24.5"
          stroke="#909090"
          shape-rendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_12"
          x="0.942032"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_12" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_12"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        prevArrow: `<button type="button" class="slick-prev">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_24_12)">
        <path d="M4.61594 27.998C4.61594 41.5278 15.5849 52.496 29.1159 52.496C42.647 52.496 53.6159 41.5278 53.6159 27.998C53.6159 14.4682 42.647 3.5 29.1159 3.5C15.5849 3.5 4.61594 14.4682 4.61594 27.998Z" stroke="#919191" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4821 27.7318C20.5214 27.5506 20.6114 27.3783 20.7522 27.2375L31.1266 16.8639C31.5172 16.4734 32.1503 16.4734 32.5409 16.8639L32.7228 17.0458C33.1133 17.4363 33.1133 18.0695 32.7228 18.46L23.0007 28.1813L32.5832 37.763C32.9737 38.1535 32.9737 38.7867 32.5832 39.1772L32.4012 39.3591C32.0107 39.7496 31.3775 39.7496 30.987 39.3591L20.6126 28.9855C20.2719 28.6448 20.2284 28.1196 20.4821 27.7318Z"
          fill="#909090" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_13"
          x="0.115936"
          y="0"
          width="58"
          height="57.996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset
            dy="1">
          <feGaussianBlur
            stdDeviation="2">
          <feComposite
            in2="hardAlpha"
            operator="out">
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_13" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_13"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true
      });
    }
  }

  function generateModalSliderMobile(element) {

    let referenceElement = element ? element : false;
    console.log(referenceElement.parentNode.parentNode);
    let dataElementMobile = referenceElement.parentNode.parentNode;
    console.log(dataElementMobile);

    let templateSlider = `<div class="modal-slider">
                            <div class="modal-slide-cta-header">
                              <div class="modal-slide-description">${dataElementMobile.dataset.name}</div>
                            </div>
                            <div class="slider-wrapper">
                            <div class="slider">`;

    
    if (referenceElement) {

      let parentSliderElement = referenceElement.closest('.section-listing__slider');

      let images = parentSliderElement.querySelectorAll('.slick-slide:not(.slick-cloned) .section-listing__image');

      images.forEach((img) => {
        if (img.dataset.image) {
          templateSlider += `<div style="height:500px; width:500px; background:url(${img.dataset.image}) center no-repeat; background-size:contain;"></div>`;
        }
      });
      templateSlider += `</div></div>
                        <div class="modal-slide-cta">
                          <div class="modal-slide-description">${dataElementMobile.dataset.description}</div>
                          <div class="modal-slide-reserve">
                            <a href="${dataElementMobile.dataset.bookpage}">
                              <button class="btn btn-primary">${dataElementMobile.dataset.book}</button>
                            </a>
                          </div>
                        </div>
                      </div>`;

      let modalBox = document.querySelector('.section-wine-resort-popup__box');

      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.slider').slick({
        dots: false,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9514 28.1135C39.0033 27.8053 38.9103 27.4774 38.6724 27.2396L28.298 16.8651C27.9074 16.4746 27.2743 16.4746 26.8837 16.8651L26.7018 17.0471C26.3112 17.4376 26.3112 18.0708 26.7018 18.4613L36.354 28.1135L26.7018 37.7658C26.3112 38.1563 26.3112 38.7895 26.7018 39.18L26.8837 39.362C27.2743 39.7525 27.9074 39.7525 28.298 39.362L38.6724 28.9875C38.9103 28.7497 39.0033 28.4218 38.9514 28.1135Z"
        fill="#ffffff" />
      <g filter="url(#filter0_d_24_12)">
        <circle
          cx="29.942"
          cy="28"
          r="24.5"
          stroke="#ffffff"
          shape-rendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_12"
          x="0.942032"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_12" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_12"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        prevArrow: `<button type="button" class="slick-prev">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_24_12)">
        <path d="M4.61594 27.998C4.61594 41.5278 15.5849 52.496 29.1159 52.496C42.647 52.496 53.6159 41.5278 53.6159 27.998C53.6159 14.4682 42.647 3.5 29.1159 3.5C15.5849 3.5 4.61594 14.4682 4.61594 27.998Z" stroke="#909090" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4821 27.7318C20.5214 27.5506 20.6114 27.3783 20.7522 27.2375L31.1266 16.8639C31.5172 16.4734 32.1503 16.4734 32.5409 16.8639L32.7228 17.0458C33.1133 17.4363 33.1133 18.0695 32.7228 18.46L23.0007 28.1813L32.5832 37.763C32.9737 38.1535 32.9737 38.7867 32.5832 39.1772L32.4012 39.3591C32.0107 39.7496 31.3775 39.7496 30.987 39.3591L20.6126 28.9855C20.2719 28.6448 20.2284 28.1196 20.4821 27.7318Z"
          fill="#ffffff" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_13"
          x="0.115936"
          y="0"
          width="58"
          height="57.996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset
            dy="1">
          <feGaussianBlur
            stdDeviation="2">
          <feComposite
            in2="hardAlpha"
            operator="out">
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_13" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_13"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
  }

  function generateModalSliderListing(element) {
    let templateSlider = `<div class="modal-slider">`;
    let referenceElement = element ? element : false;
    if (referenceElement) {
      let parentSliderElement = referenceElement.closest('.section-listing__slider');
      let images = parentSliderElement.querySelectorAll('.slick-slide:not(.slick-cloned) .section-listing__image');
      images.forEach((img) => {
        if (img.dataset.image) {
          templateSlider += `<div class="modal-slide">
              <div class="modal-slide-content">
              <div class="modal-slide-cta-header">
                  <div class="modal-slide-description">${img.dataset.name}</div>
              </div>
              <img src="${img.dataset.image}" class="modal-image ${img.dataset.ratio}" />
                <div class="modal-slide-cta">
                  <div class="modal-slide-description">${img.dataset.description}</div>
                  <div class="modal-slide-reserve">
                    <a href="${img.dataset.image}">
                      <button class="btn btn-primary">Prenota</button>
                    </a>
                  </div>
                </div>
              </div>
            </div>`
        }
      });
      templateSlider += `</div>`;
      let modalBox = document.querySelector('.section-wine-resort-popup__box');
      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.modal-slider').slick({
        dots: false,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9514 28.1135C39.0033 27.8053 38.9103 27.4774 38.6724 27.2396L28.298 16.8651C27.9074 16.4746 27.2743 16.4746 26.8837 16.8651L26.7018 17.0471C26.3112 17.4376 26.3112 18.0708 26.7018 18.4613L36.354 28.1135L26.7018 37.7658C26.3112 38.1563 26.3112 38.7895 26.7018 39.18L26.8837 39.362C27.2743 39.7525 27.9074 39.7525 28.298 39.362L38.6724 28.9875C38.9103 28.7497 39.0033 28.4218 38.9514 28.1135Z"
        fill="#909090" />
      <g filter="url(#filter0_d_24_12)">
        <circle
          cx="29.942"
          cy="28"
          r="24.5"
          stroke="#909090"
          shape-rendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_12"
          x="0.942032"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_12" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_12"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        prevArrow: `<button type="button" class="slick-prev">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_24_12)">
        <path d="M4.61594 27.998C4.61594 41.5278 15.5849 52.496 29.1159 52.496C42.647 52.496 53.6159 41.5278 53.6159 27.998C53.6159 14.4682 42.647 3.5 29.1159 3.5C15.5849 3.5 4.61594 14.4682 4.61594 27.998Z" stroke="#919191" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4821 27.7318C20.5214 27.5506 20.6114 27.3783 20.7522 27.2375L31.1266 16.8639C31.5172 16.4734 32.1503 16.4734 32.5409 16.8639L32.7228 17.0458C33.1133 17.4363 33.1133 18.0695 32.7228 18.46L23.0007 28.1813L32.5832 37.763C32.9737 38.1535 32.9737 38.7867 32.5832 39.1772L32.4012 39.3591C32.0107 39.7496 31.3775 39.7496 30.987 39.3591L20.6126 28.9855C20.2719 28.6448 20.2284 28.1196 20.4821 27.7318Z"
          fill="#909090" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_13"
          x="0.115936"
          y="0"
          width="58"
          height="57.996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset
            dy="1">
          <feGaussianBlur
            stdDeviation="2">
          <feComposite
            in2="hardAlpha"
            operator="out">
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_13" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_13"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
  }

  function generateModalSliderBySection(element) {
    let templateSlider = `<div class="modal-slider">`;
    let referenceElement = element ? element : false;
    if (referenceElement) {
      let parentSliderElement = referenceElement.closest('.homepage-sections-wrapper');
      let images = parentSliderElement.dataset.popupImages.split(',');
      images.forEach((img) => {
        if (img) {
          console.log(img)
          let url = img.split('|')[0];
          let description = img.split('|')[1];
          templateSlider += `<div class="modal-slide">
              <div class="modal-slide-content">
              <div class="modal-slide-cta">
                  <div class="modal-slide-description"></div>
              </div>
              <img src="${url}" class="modal-image vertical" />
              <div class="modal-slide-cta">
                <div class="modal-slide-description">${description}</div>
                  <div class="modal-slide-reserve">
                    <button class="btn btn-primary reservationDate--popup">Prenota</button>
                  </div>
                </div>
              </div>
            </div>`
        }
      });
      templateSlider += `</div>`;
      let modalBox = document.querySelector('.section-wine-resort-popup__box');
      modalBox.insertAdjacentHTML('beforeend', templateSlider);
      $('.modal-slider').slick({
        dots: false,
        arrows: true,
        nextArrow: `<button type="button" class="slick-next">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M38.9514 28.1135C39.0033 27.8053 38.9103 27.4774 38.6724 27.2396L28.298 16.8651C27.9074 16.4746 27.2743 16.4746 26.8837 16.8651L26.7018 17.0471C26.3112 17.4376 26.3112 18.0708 26.7018 18.4613L36.354 28.1135L26.7018 37.7658C26.3112 38.1563 26.3112 38.7895 26.7018 39.18L26.8837 39.362C27.2743 39.7525 27.9074 39.7525 28.298 39.362L38.6724 28.9875C38.9103 28.7497 39.0033 28.4218 38.9514 28.1135Z"
        fill="#909090" />
      <g filter="url(#filter0_d_24_12)">
        <circle
          cx="29.942"
          cy="28"
          r="24.5"
          stroke="#909090"
          shape-rendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_12"
          x="0.942032"
          y="0"
          width="58"
          height="58"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_12" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_12"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        prevArrow: `<button type="button" class="slick-prev">
    <svg
      width="59"
      height="58"
      viewBox="0 0 59 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_24_12)">
        <path d="M4.61594 27.998C4.61594 41.5278 15.5849 52.496 29.1159 52.496C42.647 52.496 53.6159 41.5278 53.6159 27.998C53.6159 14.4682 42.647 3.5 29.1159 3.5C15.5849 3.5 4.61594 14.4682 4.61594 27.998Z" stroke="#919191" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.4821 27.7318C20.5214 27.5506 20.6114 27.3783 20.7522 27.2375L31.1266 16.8639C31.5172 16.4734 32.1503 16.4734 32.5409 16.8639L32.7228 17.0458C33.1133 17.4363 33.1133 18.0695 32.7228 18.46L23.0007 28.1813L32.5832 37.763C32.9737 38.1535 32.9737 38.7867 32.5832 39.1772L32.4012 39.3591C32.0107 39.7496 31.3775 39.7496 30.987 39.3591L20.6126 28.9855C20.2719 28.6448 20.2284 28.1196 20.4821 27.7318Z"
          fill="#909090" />
      </g>
      <defs>
        <filter
          id="filter0_d_24_13"
          x="0.115936"
          y="0"
          width="58"
          height="57.996"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha" />
          <feOffset
            dy="1">
          <feGaussianBlur
            stdDeviation="2">
          <feComposite
            in2="hardAlpha"
            operator="out">
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_24_13" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_24_13"
            result="shape" />
        </filter>
      </defs>
    </svg>
  </button>`,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true
      }).on('setPosition', function (event, slick) {
        slick.$slides.css('height', slick.$slideTrack.height() + 'px');
      });
    }
  }

  function showModal() {
    modal.classList.remove('hide-popup');
    modal.classList.add('show-popup');
  }

  function closeModal() {
    modal.classList.remove('show-popup');
    modal.classList.add('hide-popup');
    if (modal.querySelector('.modal-slider')) {
      modal.querySelector('.modal-slider').remove();
    }
    if (modal.querySelector('.modal-details')) {
      modal.querySelector('.modal-details').remove();
    }
  }

  function showModalSlider() {
    if (document.querySelector('.modal-slider')) {
      document.querySelector('.modal-slider').style.display = 'block';
    }
  }

  function hideModalSlider() {
    if (document.querySelector('.modal-slider')) {
      document.querySelector('.modal-slider').style.display = 'none';
    }
  }

  function showReservationDates() {
    document.querySelector('.reservation-component').classList.remove('hide');
  }

  function hideReservationDates() {
    document.querySelector('.reservation-component').classList.add('hide');
  }

  function detailsToFormModal(element) {
    console.log(element)
    document.querySelector('.offerta').style.display = "block"; 
    let wrapper = element.parentNode.parentNode.parentNode
    document.querySelector('.selected-detail').innerHTML = wrapper.querySelector('.modal-details__title').textContent
    scrollToForm()
  }

  function detailsToForm(element) {
    console.log(element)
    document.querySelector('.offerta').style.display = "block"; 
    let wrapper = element.parentNode.parentNode
    document.querySelector('.selected-detail').innerHTML = wrapper.querySelector('.section-listing__title').textContent
    scrollToForm()
  }

  function scrollToForm() {
    let form = document.querySelector('.contact-form-title');
    form.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }

  if (document.querySelector('.section-carousels__slider')) {
    $('.section-carousels__slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1
    }).on('setPosition', function (event, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
  }

  if (document.querySelector('.section-listing__slider')) {
    $('.section-listing__slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            dots: false,
            arrows: false,
            slidesToShow: 1,
            swipe: false,
            swipeToSlide: false,
            touchMove: false,
            draggable: false
          }
        }
      ]
    }).on('setPosition', function (event, slick) {
      slick.$slides.css('height', slick.$slideTrack.height() + 'px');
    });
  }

  if (document.querySelector('.section-listing__main-slider')) {

    $('.section-listing__main-slider').slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    })

  }

  if (document.querySelector('.section-carousels__main-slider')) {

    $('.section-carousels__main-slider').slick({
      dots: false,
      arrows: true,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    })

  }

  /* load more */
var selection = document.querySelector('.selector') !== null;
if(selection) {
let allCarousels = Array.prototype.slice.call(selection);

const carouselperPage = 2;
document.querySelector("#loadMoreCarousels").addEventListener("click", () => {
  allCarousels.splice(0, carouselperPage).forEach(el => {
    el.classList.remove("hiddenCarousel");
    $(".section-carousels__slider").slick("refresh");
    });

    if(allCarousels.length === 0) {
      document.querySelector("#loadMoreCarousels").style.display = "none";
    }
  });
}
/*let allimages = Array.prototype.slice.call(document.querySelectorAll(".hiddenImage"));
const imagesperPage = 3;
document.querySelector("#loadMoreImages").addEventListener("click", () => {
  allimages.splice(0, imagesperPage).forEach(el => {
    el.classList.remove("hiddenImage");
    });
    if(allimages.length === 0) {
      document.querySelector("#loadMoreImages").style.display = "none";
    }
  });*/
  /*setTimeout(function() { 
  document.querySelector('iframe').setAttribute('scrolling', 'yes');
  document.querySelector('iframe').setAttribute('height', '600px');
  },2000);*/


  $(window).scroll(function() {    
      if (isScrolledIntoView('.newsletter-footer') )
        $('.book-now').css('visibility','hidden');      
      else{
        $('.book-now').css('visibility','visible');
    }
  });
 
 
  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();    
    var docViewBottom = docViewTop + $(window).height();
  
    var elemTop = $(elem).offset().top;    
    var elemBottom = elemTop + $(elem).height();   
  
    return ((elemTop < docViewBottom));
  }

})();

setTimeout(function(){

  //console.log('test2');

  //window.addEventListener("DOMContentLoaded", (event) => {

    //console.log("DOM fully loaded and parsed");

   

    const swiper = document.querySelector('.swiper-prodotto').swiper;

   

    swiper.allowTouchMove = true;

    const prevButton = document.querySelector('.swiper-prodotto .swiper-button-prev');

    const nextButton = document.querySelector('.swiper-prodotto .swiper-button-next');

 

    prevButton.addEventListener('click', function() {

    //console.log(prevButton, swiper);

      swiper.slidePrev(300, false)

     

      });

 

      nextButton.addEventListener('click', function() {

        //console.log(nextButton, swiper);

        swiper.slideNext(300, false)

       

        })

 

  //});

},500);
